import styled from 'styled-components';
import * as React from 'react';
import { alpha } from '@material-ui/core';

const StyledDiv = styled.div.attrs((args: { baseColor?: string; disableInteraction?: boolean }) => ({
    baseColor: args.baseColor,
    disableInteraction: args.disableInteraction ?? true,
}))`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-color: ${({ baseColor, theme }) => alpha(baseColor ?? theme.palette.grey[100], 0.3)};
    z-index: 1;

    ${({ disableInteraction }) => (disableInteraction ? '' : 'pointer-events: none;')}
`;

export interface DisabledOverlayProps {
    disableInteraction?: boolean;
    baseColor?: string;
}

export const DisabledOverlay: React.FC<DisabledOverlayProps> = ({ baseColor, disableInteraction }) => (
    <StyledDiv baseColor={baseColor} disableInteraction={disableInteraction} />
);
DisabledOverlay.displayName = 'DisabledOverlay';
